import { inject, Injectable } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { filter, map, Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class NavDrawerService {
    private router = inject(Router);

    drawerOpen$(): Observable<boolean> {
        return this.router.events.pipe(
            filter((event) => event instanceof NavigationEnd),
            map(() => false)
        );
    }
}
